import { render, staticRenderFns } from "./updateDataUser.vue?vue&type=template&id=ff572788&"
import script from "./updateDataUser.vue?vue&type=script&lang=js&"
export * from "./updateDataUser.vue?vue&type=script&lang=js&"
import style0 from "./updateDataUser.vue?vue&type=style&index=0&id=ff572788&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports